import { token } from "./token.js";
import { makeInternalTokens } from "./makeInternalTokens.js";
const componentTokens = {
  primaryBorderHover: token.brandPrimary600,
  primaryBorderActive: token.brandPrimary700,
  primaryBorderFocus: token.brandPrimary500,
  primaryBorderDisabled: "transparent",
  primaryColor: token.white,
  primaryColorHover: token.white,
  primaryColorActive: token.white,
  primaryColorFocus: token.white,
  primaryFill: token.brandPrimary500,
  primaryFillHover: token.brandPrimary600,
  primaryFillActive: token.brandPrimary700,
  primaryFillFocus: token.brandPrimary500,
  secondaryColor: token.gray800,
  secondaryColorDisabled: token.gray400,
  cleanBorderActive: "transparent",
  cleanFill: "transparent",
  cleanFillHover: token.gray25a,
  cleanFillActive: token.gray50a,
  cleanFillFocus: token.gray25a,
  cleanFillDisabled: "transparent",
  dangerBorderHover: token.red600,
  dangerBorderActive: token.red700,
  dangerBorderFocus: token.red500,
  dangerBorderDisabled: "transparent",
  dangerColor: token.white,
  dangerFill: token.red500,
  dangerFillHover: token.red600,
  dangerFillActive: token.red700,
  dangerFillFocus: token.red500,
  dangerFillDisabled: token.red500a50
};
const {
  internalTokens,
  declareTokens
} = makeInternalTokens({
  lightTheme: {
    "button-primary-fill-disabled": token.brandPrimary300,
    "button-primary-color-disabled": token.white,
    "button-primary-focus-ring": `0 0 0 3px rgb(${token["brandPrimary500-rgb"]} / 30%)`,
    "button-secondary-fill": token.gray25,
    "button-secondary-border": token.gray100,
    "button-secondary-fill-hover": token.gray50,
    "button-secondary-border-hover": token.gray200,
    "button-secondary-shadow-hover": token.elevation1,
    "button-secondary-fill-active": token.gray75,
    "button-secondary-border-active": token.gray300,
    "button-secondary-fill-focus": token.gray25,
    "button-secondary-border-focus": token.gray300,
    "button-secondary-fill-disabled": token.gray25,
    "button-secondary-border-disabled": token.gray50,
    "button-secondary-focus-ring": `0 0 0 3px ${token.gray50}`,
    "button-clean-color": token.gray600,
    "button-clean-color-hover": token.gray900,
    "button-clean-color-active": token.gray900,
    "button-clean-color-focus": token.gray900,
    "button-clean-border-focus": token.gray200,
    "button-clean-color-disabled": token.gray300,
    "button-clean-focus-ring": `0 0 0 3px ${token.gray50}`,
    "button-danger-focus-ring": `0 0 0 3px rgb(${token["red500-rgb"]} / 30%)`
  },
  darkTheme: {
    "button-primary-fill-disabled": `rgb(${token["brandPrimary500-rgb"]} / 50%)`,
    "button-primary-color-disabled": token.gray500a,
    "button-primary-focus-ring": `0 0 0 1px ${token.gray10}, 0 0 0 3px ${token.brandPrimary500}`,
    "button-secondary-fill": token.gray25a,
    "button-secondary-border": token.gray100a,
    "button-secondary-fill-hover": token.gray50a,
    "button-secondary-border-hover": token.gray200a,
    "button-secondary-shadow-hover": "none",
    "button-secondary-fill-active": token.gray25a,
    "button-secondary-border-active": token.gray100a,
    "button-secondary-fill-focus": token.gray25a,
    "button-secondary-border-focus": token.gray200a,
    "button-secondary-fill-disabled": token.gray25a,
    "button-secondary-border-disabled": token.gray50a,
    "button-secondary-focus-ring": `0 0 0 1px ${token.gray10}, 0 0 0 3px ${token.gray200a}`,
    "button-clean-color": token.gray600a,
    "button-clean-color-hover": token.gray1000,
    "button-clean-color-active": token.gray1000,
    "button-clean-color-focus": token.gray1000,
    "button-clean-color-disabled": token.gray400a,
    "button-clean-border-focus": "transparent",
    "button-clean-focus-ring": `0 0 0 1px ${token.gray10}, 0 0 0 3px ${token.gray200a}`,
    "button-danger-focus-ring": `0 0 0 1px ${token.gray10}, 0 0 0 3px ${token.red500}`
  }
});
export {
  componentTokens,
  declareTokens,
  internalTokens
};
//# sourceMappingURL=tokensAndThemes.js.map
